<template>
  <b-row>
    <b-col sm="12">
      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col>
            <h4 id="traffic" class="card-title mb-0">Finanzas</h4>
            <div class="small text-muted">Administración de todo el proceso financiero</div>
          </b-col>
                  <b-col cols="auto" class="d-flex align-items-center">
            <WidgetVisibilityConfig
              :widgets="widgetsMeta"
              :hidden="hiddenWidgets"
              :disabled="!visibilityLoaded"
              :locked="editingLocked"
              @toggle="onToggleWidget"
              @reset="resetWidgetsVisibility"
              @toggle-lock="setEditingLocked($event)"
            />
            <ChangelogWidget moduleKey="finances" :limit="5" />
          </b-col>
</b-row>
      </b-card>

      <b-row>
        <b-col md="9">
                  <WidgetMasonry
                    v-if="visibilityLoaded"
                    v-model="widgetsOrdered"
                    :disabled="!visibilityLoaded || editingLocked"
                    @order-end="saveWidgetOrder"
                    @resize-end="commitWidgetSize"
                  >
                    <template v-slot:default="{ item }">
                        <Widget
                          :configWidget="configWidget"
                          :reference="item.reference"
                          :hasAccess="item.hasAccess"
                          :allowHide="!editingLocked"
                          :allowDrag="!editingLocked"
                          :allowResize="!editingLocked"
                          @hide-widget="hideWidget"
                        />
                    </template>
                  </WidgetMasonry>
        </b-col>  
        <b-col md="3">

          <b-list-group class="mb-1" v-if="configSubView.elements.settings">
            <b-list-group-item href="#" class="flex-column align-items-start" @click="openSettings()">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">Cajas y Cuentas</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                Configuraciones de cajas y cuentas
              </p>
            </b-list-group-item>
          </b-list-group>

          <b-list-group class="mb-1" v-if="configSubView.elements.details">
            <b-list-group-item href="#" class="flex-column align-items-start" @click="openCashDetail()">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">Movimientos</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                Ver movimientos detallados por caja/cuenta
              </p>
            </b-list-group-item>
          </b-list-group>
          
          <b-list-group class="mb-1" v-if="configSubView.elements.cheques">
            <b-list-group-item href="#" class="flex-column align-items-start" @click="openCheques()">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">Cartera de Valores</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                Ver los valores en cartera
              </p>
            </b-list-group-item>
          </b-list-group>

          <hr v-if="arr.PHPCustom.length && configSubView.elements.php_custom">
          <b-list-group class="mt-2" v-if="arr.PHPCustom.length && configSubView.elements.php_custom">
            <b-list-group-item v-for="item in arr.PHPCustom" :key="item.id" href="#" class="flex-column align-items-start" @click="openPHPCustom(item)">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">{{item.name}}</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                {{item.observations}}
              </p>
            </b-list-group-item>
          </b-list-group>          
        </b-col>        
      </b-row>

    </b-col>
  </b-row>
</template>
<script>
  //import serviceAPI from './services'
  import Error from '@/handler/error'
  import Session from '@/handler/session'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'
  import Widget from '@/components/inc/widget/widget'
  import WidgetVisibilityConfig from '@/components/inc/widget/WidgetVisibilityConfig'
  import WidgetMasonry from '@/components/inc/widget/WidgetMasonry'
  import DashboardWidgetsHelper from '@/components/inc/widget/DashboardWidgetsHelper'
import ChangelogWidget from '@/components/inc/changelog/ChangelogWidget'
  import ServicesPHP from '@/components/modules/users/php/staff/services'

  export default {
    mixins: [DashboardWidgetsHelper],
    components: {
      Widget,
      WidgetVisibilityConfig,
      WidgetMasonry,
      ChangelogWidget
    },
    data: () => {
      return {
        access: {
          module_id: Modules.FINANZAS,
          profile_id: Profiles.PERSONAL,
          view_reference: 'dashboard',
          elements: {}
        },
        configWidget: {
          module_id: Modules.FINANZAS,
          profile_id: Profiles.PERSONAL,
          elements: {}
        },
        configSubView: {
          module_id: Modules.FINANZAS,
          profile_id: Profiles.PERSONAL,
          elements: {
            settings: true,
            details: true,
            cheques: true,
            php_custom: true,
          }
        },           
        primaryColor: '',
        arr: {
          PHPCustom: []
        }        
      }
    },
    created () {
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */

      this.initDashboardWidgets()

      
      /* Configurar permisos de las sub vistas */
      this.configSubView.elements.settings = Helper.showAccessView(this.configSubView, 'settings')      
      this.configSubView.elements.details = Helper.showAccessView(this.configSubView, 'cashDetail')      
      this.configSubView.elements.cheques = Helper.showAccessView(this.configSubView, 'cheques')      
      this.configSubView.elements.php_custom = Helper.showAccessPHPCustom()
      /* Fin configuracion */         
    },
    mounted() {
      this.setup()
      this.getPHPCustom()
    }, 
    methods: {
      setup () {        
        if(Session.getSession().settings) {    
          this.primaryColor = Session.getSession().settings.color_primary
                    
          this.createCSS()
        }
      },         
      createCSS() {
        var hoja = document.createElement('style')
        hoja.innerHTML = ""      
        hoja.innerHTML = hoja.innerHTML  + ".list-group-item-action:hover, .list-group-item-action:focus { background-color: " + this.primaryColor + "; }"

        document.body.appendChild(hoja);
      }, 
      openCashDetail() {
        this.$router.push({ name: 'FinancesStaffCashDetail' })
      }, 
      openCheques() {
        this.$router.push({ name: 'FinancesStaffCheques' })
      }, 
      openSettings() {
        this.$router.push({ name: 'FinancesStaffSettings' })
      },    

      getPHPCustom() {
        ServicesPHP.obtenerPHPByModule(Modules.FINANZAS)
        .then((response) => {
          this.arr.PHPCustom = response.data       
        })
      },
      openPHPCustom(item) {
        this.$router.push({ name: 'ViewStaffViewPHPCustom', params: {id: item.id} })
      }      
    }    
   
  }
</script>

<style>

</style>
